<template>
    <div class="stu-club">
        <div class="club-grid">
            <club-card
                v-for="(item, index) in clubList"
                :key="index"
                :club="item"
                :is-student="user_type == 'student'"
                :default-club-image="defaultClubImage"
                :is-joined="true"
                @click.native="actionToClubDetail(item)"
            />
        </div>
        
    </div>
</template>
<script>
import {
    getStudentClubs,
    postRequest
} from '../../api/eclub'
import {
    getUserId,getUserType
} from '../../utils/store'
import ClubCard from '@/components/ClubCard'

export default ({
    name: 'index',
    components: {
        ClubCard
    },
    data() {
        return {
            user_id: getUserId(),
            clubList: [],
            discussionList: [],
            leaderClubIDs: [],
            user_type: getUserType(),
            defaultClubImage: 'https://via.placeholder.com/150'// Temporary placeholder image
        }
        
    },
    mounted() {
        this.fetchData()
        this.fetchStudentClubPosts()
    },
    methods: {
        actionToClubDetail (data) {
            this.$router.push({
                name: 'Club Detail',
                query: {
                    club_id: data._id.$id,
                }
            })
            console.log(data)

        },
        fetchData() {
            getStudentClubs(this.user_id).then((res) => {
                if (res.data.code === 0 && Array.isArray(res.data.data)) {
                    this.clubList = res.data.data
                    this.leaderClubIDs = this.clubList
                        .filter(club => club.user_role === 'leader')
                        .map(club => club._id.$id)
                } else {
                    this.clubList = []
                    console.error('Invalid club list data format')
                }
            }).catch(error => {
                this.clubList = []
                console.error('Error fetching clubs:', error)
            })
        },
        fetchStudentClubPosts() {
            postRequest('getStudentClubPosts', {
                student_id: this.user_id
            }).then((res) => {
                if (res.data.code === 0 && Array.isArray(res.data.data)) {
                    this.discussionList = res.data.data
                } else {
                    this.discussionList = []
                    console.error('Invalid discussion list data format')
                }
            }).catch(error => {
                this.discussionList = []
                console.error('Error fetching discussions:', error)
            })
        },
        formatDate(timestamp) {
            if (!timestamp) return '-'
            const date = new Date(timestamp * 1000)
            return date.toLocaleString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            })
        },
        tableCellstyle() {
            return 'background:  #FAE3E4;border:1px solid white;text-align:center; font-family: GravityBold;'
        },
    }
})
</script>
<style scoped lang="scss">
.stu-club {
    padding: 20px;
}

.club-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    margin-bottom: 30px;
}

.club-card {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    overflow: hidden;
    transition: transform 0.3s ease;
    cursor: pointer;

    &:hover {
        transform: translateY(-5px);
    }
}

.club-image {
    width: 100%;
    height: 150px;
    overflow: hidden;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}

.club-info {
    padding: 15px;

    .club-name {
        margin: 0;
        font-size: 16px;
        font-weight: 600;
        color: #333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .club-description {
        margin: 8px 0 0;
        font-size: 14px;
        color: #666;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }
}

::v-deep  .el-table .custom-row-bg {
    // background: #FF8833;
}

::v-deep  .el-table .custom-head-cell {
    background: #FF8833;
    color: white;
    // text-align: center;
    // border: 1px solid white;
    box-sizing: border-box;
    font-family: GravityBold;
}
</style>
